// import {fetch as nodeFetch} from 'node-fetch';
// const fetch = nodeFetch.default || nodeFetch;
const {FetchRequest} = require('data-fetcher/data-fetcher');

class IsometricFetchRequest extends FetchRequest {
    constructor (req, requestKey, requestUrl, datasource, params) {
        super(req, requestKey, requestUrl, datasource, params);
        // Turn off memory storage 
        // Maybe make this configurable in the future
        this.store = false;
    }

    fetch (url, fetchConfig) {
        Promise.reject("node-fetch 2.x and webpack do not play nicely")
        // Be sure to use isometric fetch
        return fetch(url, fetchConfig);
    }
}

module.exports = IsometricFetchRequest;